<template>
    <!-- Page Heading -->
    <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-lg-10">
            <h2>{{ $t("navigations.issue list") }}</h2>
        </div>
    </div>

    <div class="row g-3 mb-2">
        <div class="col-12 py-3">

            <!-- Search Filter Section -->
            <div class="ibox-content mb-1 px-3 py-2">
                <div class="form-group mb-1">
                    <div class="d-flex flex-column flex-lg-row my-2 my-lg-0 mb-lg-0">

                        <div class="form-group mb-lg-0 w-100 px-1">
                            <label class="mb-0">VisitType</label>
                            <select class="form-control" v-model="searchField.visitType">
                                <option value="">Select</option>
                                <option v-for="cat in visitType" :key="cat" :value="cat">
                                    {{ cat }}
                                </option>
                            </select>
                        </div>

                        <div class="form-group mb-lg-0 w-100 px-1">
                            <label class="mb-0">Status</label>
                            <select class="form-control" v-model="searchField.status">
                                <option value="">Select</option>
                                <option v-for="stat in statuses" :key="stat" :value="stat">
                                    {{ stat }}
                                </option>
                            </select>
                        </div>

                        <div class="form-group mb-lg-0 w-100 px-1">
                            <label class="mb-0">Priority</label>
                            <select class="form-control" v-model="searchField.priority">
                                <option value="">Select</option>
                                <option v-for="prio in priorities" :key="prio" :value="prio">
                                    {{ prio }}
                                </option>
                            </select>
                        </div>

                        <span class="col-sm-12 col-lg-2 save_btn my-1 my-lg-0 mx-lg-1 align-self-end" @click="search()">
                            Search
                        </span>

                    </div>
                </div>
            </div>

            <!-- Issue List Grid -->
            <div class="ibox-body">
                <div class="ibox-title style_2 d-flex justify-content-between">
                    <h5 class="mt-1">Issue List</h5>
                </div>

                <div class="ibox-content">
                    <!-- Loading -->
                    <div class="text-center" v-if="loadingIssues">
                        <img src="../../assets/img/loading.gif" width="15" alt="Loading" />
                        <div>
                            {{ $t("navigations.please wait while the list is being loaded") }}
                        </div>
                    </div>

                    <template v-else>
                        <!-- Empty state -->
                        <div class="text-center" v-if="!issueList.length">
                            {{ $t("navigations.no data available") }}
                        </div>

                        <!-- Table -->
                        <div v-else class="table-responsive">
                            <table class="table table-striped table-bordered dataTables">
                                <thead>
                                    <tr>
                                           <th v-if="selectedcolumnobj['IssueLogId']" class="sort_block" @click="SortSelected('IssueLogId')">
                                            <div class="d-flex justify-content-between">
                                               Issue Log Id
                                                <span>
                                                    <i class="fa fa-long-arrow-up"></i>
                                                    <i class="fa fa-long-arrow-down"></i>
                                                </span>
                                            </div>
                                        </th>
                                        <th v-if="selectedcolumnobj['Subject']" class="sort_block" @click="SortSelected('Subject')">
                                            <div class="d-flex justify-content-between">
                                                Subject
                                                <span>
                                                    <i class="fa fa-long-arrow-up"></i>
                                                    <i class="fa fa-long-arrow-down"></i>
                                                </span>
                                            </div>
                                        </th>
                                       <th v-if="selectedcolumnobj['Category']" class="sort_block" @click="SortSelected('Category')">
                                            <div class="d-flex justify-content-between">
                                                Category
                                                <span>
                                                    <i class="fa fa-long-arrow-up"></i>
                                                    <i class="fa fa-long-arrow-down"></i>
                                                </span>
                                            </div>
                                        </th>
                                         <th v-if="selectedcolumnobj['Severity']" class="sort_block" @click="SortSelected('Severity')">
                                            <div class="d-flex justify-content-between">
                                                Severity
                                                <span>
                                                    <i class="fa fa-long-arrow-up"></i>
                                                    <i class="fa fa-long-arrow-down"></i>
                                                </span>
                                            </div>
                                        </th>
                                        <th v-if="selectedcolumnobj['Status']" class="sort_block" @click="SortSelected('Status')">
                                            <div class="d-flex justify-content-between">
                                                Status
                                                <span>
                                                    <i class="fa fa-long-arrow-up"></i>
                                                    <i class="fa fa-long-arrow-down"></i>
                                                </span>
                                            </div>
                                        </th>
                                     
                                         <th v-if="selectedcolumnobj['Priority']" class="sort_block" @click="SortSelected('Priority')">
                                            <div class="d-flex justify-content-between">
                                                Priority
                                                <span>
                                                    <i class="fa fa-long-arrow-up"></i>
                                                    <i class="fa fa-long-arrow-down"></i>
                                                </span>
                                            </div>
                                        </th>
                                        <th v-if="selectedcolumnobj['DueDate']" class="sort_block" @click="SortSelected('DueDate')">
                                            <div class="d-flex justify-content-between">
                                                Due Date
                                                <span>
                                                    <i class="fa fa-long-arrow-up"></i>
                                                    <i class="fa fa-long-arrow-down"></i>
                                                </span>
                                            </div>
                                        </th>
                                     
                                        <th v-if="selectedcolumnobj['ResolvedAt']" class="sort_block" @click="SortSelected('ResolvedAt')">
                                            <div class="d-flex justify-content-between">
                                                Resolved Date
                                                <span>
                                                    <i class="fa fa-long-arrow-up"></i>
                                                    <i class="fa fa-long-arrow-down"></i>
                                                </span>
                                            </div>
                                        </th>
                                       <th v-if="roleprivileges.includes('CRA Task Management View Issue')" class="text-center">
                                      {{ $t("navigations.view") }}
                                     </th>

                                       <th v-if="roleprivileges.includes('CRA Task Management Delete Issue')" class="text-center">{{ $t("navigations.delete") }}</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="item in issueList" :key="item.id">
                                        <td v-if="selectedcolumnobj['IssueLogId']">{{ item.issueLogId }}</td>
                                        <td v-if="selectedcolumnobj['Subject']">{{ item.subject }}</td>
                                        <td v-if="selectedcolumnobj['Category']">{{ item.category }}</td>
                                        <td v-if="selectedcolumnobj['Severity']">{{ item.severity }}</td>
                                        <td v-if="selectedcolumnobj['Status']">{{ item.status }}</td>
                                        <td v-if="selectedcolumnobj['Priority']">{{ item.priority }}</td>
                                        <td v-if="selectedcolumnobj['DueDate']">{{ formatdatetime(item.metrics.dueAt) }}</td>
                                        <td v-if="selectedcolumnobj['ResolvedAt']">{{ formatdatetime(item.metrics.resolvedAt) }}</td>
                                       
                                        <td class="text-center" v-if="roleprivileges.includes('CRA Task Management View Issue')">
                                            <i class="fa fa-eye editicon" style="color:#a13b7c" @click="EditIssue(item.id)"></i>
                                        </td> 
                                         <!-- <td v-if="isInvestigator" class="text-center">
                                            <i class="fa fa-eye editicon" style="color:#a13b7c" @click="EditIssue(item.id)"></i>
                                        </td> -->
                                        <td class="text-center" v-if="roleprivileges.includes('CRA Task Management Delete Issue')">
                                            <i class="fa fa-trash edit-delete" style="color:#a13b7c" @click="DeleteIssue(item.id)"></i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Pagination -->
                        <div class="row mt-1 mx-0">
                            <div class="col-lg-12 px-0">
                                <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                                    <div class="d-flex justify-content-lg-end px-0">
                                        <v-pagination
                                            v-model="currentPage"
                                            :pages="totalPages"
                                            :range-size="1"
                                            active-color="#618bd7"
                                            @update:modelValue="loadPage"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <createCraIssue
  v-if="showIssueModal"
  :issueId="issueId"
  @close="closeIssueModal"
  @showIssue="getIssueList"
/>

                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script src="./CraIssueList.js"></script>
